function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, Object) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'users-list': true
        },
      }, (function() {
        var __jade_nodes = [];
        const max = $attr(`show-max`) >= 0 ? $attr(`show-max`) : 0;;
        const users = $attr(`users`).slice(0, max).reverse();;
        const truncatedCount = $attr(`users`).length - max;;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'icon-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (users);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, user, $index) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-user-icon", {
                    "attrs": {
                      name: user.name,
                      'show-tooltip': $attr(`show-tooltip`),
                      'tooltip-placement': $attr(`tooltip-placement`),
                    },
                    "on": {
                      click: $attr(`clickable`) ? () => $helpers.handleUserIconClick(user) : null,
                    },
                    "class": {
                      clickable: $attr(`clickable`),
                    },
                  }));;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var $index = $$objKey;
                  if ($$obj.hasOwnProperty($index)) {
                    $$iterated = true;
                    var user = $$obj[$index];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-user-icon", {
                        "attrs": {
                          name: user.name,
                          'show-tooltip': $attr(`show-tooltip`),
                          'tooltip-placement': $attr(`tooltip-placement`),
                        },
                        "on": {
                          click: $attr(`clickable`) ? () => $helpers.handleUserIconClick(user) : null,
                        },
                        "class": {
                          clickable: $attr(`clickable`),
                        },
                      }));;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((truncatedCount > 0) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: $attr(`clickable`) ? $helpers.handleMoreTextClick : null
            },
            "class": Object.assign({}, {
              clickable: $attr(`clickable`)
            }, {
              'more-text': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("+ " + (truncatedCount) + " " + ($attr(`more-text`)) + "");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;